//  src/App.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import GetStarted from "./pages/GetStarted";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Onboarding from "./pages/Onboarding";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import OnboardingRoute from "./components/OnboardingRoute";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import PostLogin from "./pages/PostLogin";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { useIntl } from "react-intl";

import DashboardLayout from "./dashboard/DashboardLayout";
import DashboardHome from "./dashboard/DashboardHome";
import Properties from "./dashboard/Properties";
import Leads from "./dashboard/Leads";
import Notifications from "./dashboard/Notifications";
import Subscription from "./dashboard/Subscription";
import CompanySettings from "./dashboard/CompanySettings";
import Profile from "./dashboard/ProfileUsers";
import Users from "./dashboard/Users";
import AddUser from "./dashboard/AddUser";
import Integration from "./dashboard/Integration";
import ChatbotSettings from "./dashboard/ChatbotSettings";
import AgentAssignmentSettings from "./dashboard/settings/AgentAssignmentSettings";
import Help from "./dashboard/Help";
import EmailLeadSettings from "./dashboard/EmailLeadSettings";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function MainRoutes() {
  const { user, checkingUser, profileComplete } = useAuth();
  const intl = useIntl();

  if (checkingUser) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>{intl.formatMessage({ id: "loading.label", defaultMessage: "Loading..." })}</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<GetStarted />} />
      <Route path="/get-started" element={<GetStarted />} />
      <Route path="/login" element={<Login />} />
      <Route path="/post-login" element={<PostLogin />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />

      <Route
        path="/onboarding"
        element={
          <OnboardingRoute>
            <Onboarding />
          </OnboardingRoute>
        }
      />

      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardHome />} />
        <Route path="properties" element={<Properties />} />
        <Route path="leads" element={<Leads />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="subscription" element={<Subscription />} />
        <Route path="company-settings" element={<CompanySettings />} />
        <Route path="profile" element={<Profile />} />
        <Route path="users" element={<Users />} />
        <Route path="users/add" element={<AddUser />} />
        <Route path="integration" element={<Integration />} />
        <Route path="chatbot-settings" element={<ChatbotSettings />} />
        <Route path="agent-assignment" element={<AgentAssignmentSettings />} />
        <Route path="email-lead-settings" element={<EmailLeadSettings />} />
        <Route path="help" element={<Help />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <MainRoutes />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </AuthProvider>
  );
}

export default App;
